import App from '@/App.vue';
import '@/plugins/ability';
import '@/plugins/ability-can-component';
import i18n from '@/plugins/i18n';
import '@/plugins/is-admin';
import '@/plugins/is-commercial';
import '@/plugins/device-sniffing';
import '@/plugins/sweetalert2';
import '@/plugins/typescript-string-operations';
import '@/plugins/v-lazy-image';
import '@/plugins/vue-google-charts';
import '@/plugins/vue-masonry';
import '@/plugins/vue-business-hours';
import '@/plugins/vue-cookies';
import '@/plugins/vue-currency-input';
import '@/plugins/vue-percent-input';
import '@/plugins/vue-rx';
import '@/plugins/vue-sortable-list';
import '@/plugins/vue-tippy';
import '@/plugins/vuelidate';
import '@/registerServiceWorker';
import router from '@/router';
import { notificationsService } from '@/services';
import '@babel/polyfill';
import Vue from 'vue';

Vue.config.productionTip = false;

Vue.config.errorHandler = (err: any, vm: Vue, info: string) => {
    if (err.response) {
        if (err.response.status === 401) {
            router.push('/errors/401');
        }
        if (err.response.status === 403) {
            router.push('/errors/403');
        }
        if (err.response.status === 404) {
            router.push('/errors/404');
        }
        if (err.response.status === 500) {
            notificationsService.showToastErrorNotification();
        }
    }
};

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
